import env from "@/env.mjs";
import { paths } from "@frend-digital/centra-types/oas";
import { createCentraClient } from "@frend-digital/centra/oas";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { CentraProduct } from "../atomicSetup";
import formatProductCard from "../formatters/formatProductCards/formatProductCard";

const client = createCentraClient(env.NEXT_PUBLIC_CENTRA_CHECKOUT_API);

export const productsQuery = (
  options: NonNullable<
    paths["/products"]["post"]["requestBody"]
  >["content"]["application/json"]
) =>
  queryOptions({
    queryKey: ["products", options],
    queryFn: async () => {
      const { data, error } = await client.POST("/products", {
        body: options,
      });

      if (error) {
        return {
          ...error,
          products: [],
          total: 0,
        };
      }

      return data;
    },
  });

export const useProductCardsByIds = (ids: string[]) => {
  return useQuery({
    ...productsQuery({
      products: ids.map(String),
    }),

    select: (data) =>
      data.products?.map((p) =>
        formatProductCard(p as unknown as CentraProduct)
      ) || [],
  });
};
